import { getViewportWidth } from "utils/viewport";

const homepageItems = document.querySelector("[data-homepage-items]");
const button = document.querySelector("[data-homepage-more]");
const findRiverItemsOffset = getViewportWidth() < 768 ? 10 : 8;

const hideRiverItems = (items) => {
  [...items]
    .slice(findRiverItemsOffset, items.length)
    .map((item) => item.classList.add("is-hidden"));
};

const showAllItems = (items) => {
  [...items].map((item) => item.classList.remove("is-hidden"));
  button.classList.add("is-hidden");
  window.updateElementQueries();
};

const showMoreButton = (items) => {
  if (button) {
    button.classList.remove("is-hidden");

    button.addEventListener("click", () => {
      showAllItems(items);
    });
  }
};

if (homepageItems && button) {
  const items = homepageItems.querySelectorAll(
    "[data-homepage-items] > *:not(.resize-sensor)"
  );
  if (items.length > findRiverItemsOffset) {
    hideRiverItems(items);
    showMoreButton(items);
  }
}
